import React from 'react';

export const AuthorizationContext = React.createContext<any>(null);
